"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

require("./index.css");

var LoaderIcon = function (_a) {
  var className = _a.className;
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "loader " + className
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", {
      className: "one"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "two"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "three"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "four"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "five"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "six"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "seven"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "eight"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "nine"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "ten"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "eleven"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "twelve"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "thirteen"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "fourteen"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "fifteen"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "sixteen"
    }, void 0)]
  }), void 0);
};

var Loader = function (_a) {
  var className = _a.className,
      dataTestId = _a.dataTestId,
      isVisible = _a.isVisible;
  return isVisible ? (0, jsx_runtime_1.jsx)("div", __assign({
    className: "loader-contain",
    "data-testid": dataTestId
  }, {
    children: (0, jsx_runtime_1.jsx)("div", __assign({
      className: "loader-holder"
    }, {
      children: (0, jsx_runtime_1.jsx)(LoaderIcon, {
        className: className
      }, void 0)
    }), void 0)
  }), void 0) : null;
};

Loader.propTypes = {
  dataTestId: prop_types_1.string,
  isVisible: prop_types_1.bool,
  className: prop_types_1.string
};
Loader.defaultProps = {
  dataTestId: 'Loading',
  isVisible: true,
  className: 'loader-spinner'
};
exports.default = Loader;